import { html_logo, 
    css, 
    javascript, 
    material, 
    react, 
    tailwindcss, 
    redux,
    typescript,
    bootstrap,
    express,
    git,
    mongodb,
    next,
    node,
    npm,
    sass,
    github,
    digital_marketingl, 
    SEO, 
    onpageseo, 
    social_media,astra,
    elementor,
    mailchimp,
    website_optimization,
    woocommerce,
    yoast, 
    canva, 
    photoshop,
    premier } from '../assets/index.js';

export const webDevelopment = [
    {
        id: 1,
        icon: html_logo,
        desc: 'HTML',
    },
    {
        id: 2,
        icon: css,
        desc: 'CSS',
    },
    {
        id: 3,
        icon: javascript,
        desc: 'Javascript',
    },
    {
        id: 4,
        icon: react,
        desc: 'React Js',
    },
    {
        id: 5,
        icon: node,
        desc: 'Node Js',
    },
    {
        id: 6,
        icon: express,
        desc: 'Express Js',
    },
    {
        id: 7,
        icon: mongodb,
        desc: 'MongoDB',
    },
    {
        id: 8,
        icon: next,
        desc: 'Next Js',
    },
    {
        id: 9,
        icon: redux,
        desc: 'Redux Toolkit',
    },
    {
        id: 10,
        icon: typescript,
        desc: 'Typescript',
    },
    {
        id: 11,
        icon: tailwindcss,
        desc: 'Tailwind',
    },
    {
        id: 12,
        icon: material,
        desc: 'Material ui',
    },
    {
        id: 13,
        icon: sass,
        desc: 'SASS',
    },
    {
        id: 14,
        icon: bootstrap,
        desc: 'Bootstrap',
    },
    {
        id: 15,
        icon: git,
        desc: 'Git',
    },
    {
        id: 16,
        icon: github,
        desc: 'Github',
    },
    {
        id: 17,
        icon: npm,
        desc: 'npm',
    },
    
    
];

export const digitalMarketing = [
    {
        id:1,
        icon:digital_marketingl,
        desc:"digital_marketingl",
    },
    {
        id:2,
        icon:SEO,
        desc:"SEO",
    },
    {
        id:3,
        icon:onpageseo,
        desc:"onpageseo",
    },
    {
        id:4,
        icon:social_media,
        desc:"social_media",
    },
];

export const wordpressCms = [
    {
        id:1,
        icon:astra,
        desc:"astra",
    },
    {
        id:2,
        icon:mailchimp,
        desc:"mailchimp",
    },
    {
        id:3,
        icon:woocommerce,
        desc:"woocommerce",
    },
    {
        id:4,
        icon:elementor,
        desc:"elementor",
    },
    {
        id:5,
        icon:yoast,
        desc:"yoast",
    },
    {
        id:6,
        icon:website_optimization,
        desc:"website optimization",
    },
    
];

export const editingSkills = [
    {
        id:1,
        icon:canva,
        desc:"Canva",
    },
    {
        id:2,
        icon:photoshop,
        desc:"Photoshop",
    },
    {
        id:3,
        icon:premier,
        desc:"Premier pro",
    }
];
